import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import {convertTotalPage} from 'function/converter';
import {
  ResponseSearchUser,
  UserProfile,
} from 'interfaces/interface';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import {minmax} from 'utils/minmax';

/**
 * 작업자 목록 컴포넌트의 Props 타입
 * @property {ResponseSearchUser | null} data - 검색된 사용자 데이터
 * @property {number} currentPage - 현재 페이지
 * @property {React.Dispatch<React.SetStateAction<number>>} setCurrentPage - 현재 페이지 설정 함수
 * @property {(worker: UserProfile) => void} onClickWorker - 작업자 클릭 핸들러
 */
type Props = {
  data: any;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  onClickWorker: (worker: UserProfile) => void;
};

/**
 * 작업자 목록 컴포넌트
 * 작업자 목록을 표시하는 컴포넌트입니다.
 * @param {Props} props - 작업자 목록 컴포넌트의 props
 * @returns {JSX.Element} 작업자 목록 컴포넌트
 */
const WorkerList = ({
  data,
  currentPage,
  setCurrentPage,
  onClickWorker,
}: Props) => {
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    if (data) {
      const resTotalPage = convertTotalPage(data.count ?? 0, 10);
      setTotalPage(resTotalPage);
    }
  }, [data]);

  return (
    <>
      <ResultArea>
        <ResultHeader>
          <DefaultText
            text=""
            textStyle={{...ResultHeaderTextStyle, width: minmax(50)}}
          />
          <DefaultText
            text="name"
            textStyle={{...ResultHeaderTextStyle, flex: 1}}
          />
          <DefaultText
            text="phoneNumber"
            textStyle={{...ResultHeaderTextStyle, flex: 2}}
          />
          <DefaultText
            text="gender"
            textStyle={{...ResultHeaderTextStyle, flex: 1}}
          />
        </ResultHeader>

        <ResultList>
          {data && data.count ? (
            data?.tongPlacePermissionProfile.map((item: any, index: any) => (
              <ResultItem
                key={index}
                onClick={() => {
                  onClickWorker(item);
                }}>
                <DefaultText
                  text={((currentPage - 1) * 10 + index + 1).toString()}
                  textStyle={{...ResultItemStyle, width: minmax(50)}}
                />
                <DefaultText
                  text={item.name}
                  textStyle={{...ResultItemStyle, flex: 1}}
                />
                <DefaultText
                  text={formatPhoneNumber({
                    phone: item.phone,
                    locale: item.locale,
                  })}
                  textStyle={{...ResultItemStyle, flex: 2}}
                />
                <DefaultText
                  text={item.gender?.toLowerCase()}
                  textStyle={{...ResultItemStyle, flex: 1}}
                />
              </ResultItem>
            ))
          ) : (
            <DefaultText
              text="noDataMsgWorkerListDocuments"
              textStyle={{
                color: colors.darkGray,
                textAlign: 'center',
                margin: `${minmax(12)} 0`,
              }}
            />
          )}
        </ResultList>
      </ResultArea>
      {data && data.count ? (
        <Pagination
          totalPage={totalPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      ) : null}
    </>
  );
};

export default WorkerList;

const ResultArea = styled.div`
  width: 100%;
  margin-top: ${minmax(28)};
  margin-bottom: ${minmax(40)};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordBreak: 'break-all',
};

const ResultList = styled.ul`
  border-bottom: 1px solid ${colors.darkGray};
`;
const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  border-bottom: 1px solid ${colors.lightGrey};
  position: relative;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
`;
